import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import FormUp from 'grommet/components/icons/base/FormUp';
import FormDown from 'grommet/components/icons/base/FormDown';
import Animate from 'grommet/components/Animate';
import Accordion from 'grommet/components/Accordion';
import AccordionPanel from 'grommet/components/AccordionPanel';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
let ConfigDetailsOfRackServers;
let ServerBOMItems=[];
//var ConfigDetails = [];
var ActiveAccordianBgColor;
class RackDetails extends Component {
    constructor() {
        super();
        this.state = {
            contentVisible: true,
            HeadingAcc: 'Collapse Configure Solution',
            ActiveTabIndex1: [0],
            Activedata: '',
            animate: true
        }
        this.onDivClick = this.onDivClick.bind(this);
        this.loopConfigureItems = this.loopConfigureItems.bind(this);
        this.OpenParallelActive = this.OpenParallelActive.bind(this);
     
    }

    OpenParallelActive(e) {
        ActiveAccordianBgColor = false;
        var array = [];
        array = e;
        this.setState({ ActiveTabIndex1: array });
    }
    onDivClick() {
        var SetTitle;
        if (!this.state.contentVisible) {
            SetTitle = 'Collapse Configure Solution'
        } else {
            SetTitle = 'Expand Configure Solution'
        }
        this.setState({ contentVisible: !this.state.contentVisible, HeadingAcc: SetTitle });
    }
    // componentWillMount() {
    //     ConfigDetails = this.props.MapContent.Item;
    // }

    componentWillReceiveProps(nextProps, nextState) {

    }

    ChildAccordianActive(d) {
        var index = 0;
        if (Array.isArray(this.props.MapContent)) {
            this.props.MapContent.map((val, id) => {
                if (d == val["@Name"]) {
                    index = id;
                }
            });
        }
        var array = [];
        array.push(index);
        ActiveAccordianBgColor = true;
        this.setState({ ActiveTabIndex1: array });
        this.setState({ animate: true });
    }

    styledHeading = (heading)=>{
        return <sapn  
        style={{fontSize: '0.95em', fontWeight:'bold'}}
        >
       {heading}
      </sapn>
    }

    loopConfigureItems(Arraydata) {
        ConfigDetailsOfRackServers = Arraydata.map((val, idx) => {
            ServerBOMItems = []
            if(val.RackComponents)
            {
            if (Array.isArray(val.RackComponents.Roles.Role)) {
                val.RackComponents.Roles.Role.map((role) => {
                    role.Item.map((rackwise, id) => {
                        if (Array.isArray(rackwise)) {
                            rackwise.map((data) => {
                                if (data['@Name'] === "HP Moonshot System") {
                                    data['@Name'] = "HPE Moonshot System"
                                }
                                /* Changes for displaying rack details in multiple lines*/
                                let Data = []
                                if (data['@Name'] !== undefined) {
                                    Data = (data['@Name']).split(',');
                                }
                                if (Data.length > 1) {
                                    ServerBOMItems.push(<ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                                        <span style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>{this.styledHeading(data['@Quantity'] + ' x ' + Data[0] + ", " + Data[1])} <br /> {Data[2]} <br /> {Data[3]}  </span>
                                    </ListItem>)
                                }

                                else {
                                    ServerBOMItems.push(<ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                                        <span style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>{data['@Quantity'] + ' x ' + data['@Name']}  </span>
                                    </ListItem>)
                                }})
                        } else {
                            if (rackwise['@Name'] === "HP Moonshot System") {
                                rackwise['@Name'] = "HPE Moonshot System"
                            }
                            let Data = []
                            if (rackwise['@Name'] !== undefined) {
                                Data = (rackwise['@Name']).split(',');
                            }
                            if (Data.length > 1) {

                                ServerBOMItems.push(<ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                                    <span style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>{this.styledHeading(rackwise['@Quantity'] + ' x ' + Data[0] + ", " + Data[1])}<br /> {Data[2]} <br /> {Data[3]} </span>
                                </ListItem>)
                            }
                            else {
                                ServerBOMItems.push(<ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                                    <span style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>{rackwise['@Quantity'] + ' x ' + rackwise['@Name']}  </span>
                                </ListItem>)
                            }
                        }})
                })
            } else {
                if (val.RackComponents.Roles.Role.Item['@Name'] === "HP Moonshot System") {
                    val.RackComponents.Roles.Role.Item['@Name'] = "HPE Moonshot System"
                }
                ServerBOMItems.push(<ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                    <span style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>{val.RackComponents.Roles.Role.Item['@Quantity'] + ' x ' + val.RackComponents.Roles.Role.Item['@Name']}  </span>
                </ListItem>)
            }

            return (
                <AccordionPanel heading={val["@Name"]}>
                    <List>
                        {ServerBOMItems}
                    </List>
                </AccordionPanel>
            );
            }
        });
    }

    getSummary = () => {
        let list = [];
        if (this.props.summary) {
            this.props.summary[0].Item.forEach(item => {
                let name = item['@Name'];
                if(item['@Type'] !=='Servers') {
                    name = item['@Name'].split(',');
                }
                if (name.length > 1 && item['@Type'] !== 'Servers') {
                    name.forEach((element, index) => {
                        if (index === 0)
                            list.push(`${item['@Quantity']} X ${element}`);
                        else list.push(`${element}`);

                    });
                } else {
                    list.push(`${item['@Type']} :  ${item['@Quantity']} X ${item['@Name']}`);
                }
            })
        }

        return (
        <AccordionPanel heading={'Summary'}>
        <List>
            {list.map(element => 
                <ListItem align="start" alignContent="start" justify='between' className="ListItemsCls">
                    <span  style={{ width: '100%', fontSize: '0.835em', color: '#000' }}>
                        {element}
                    </span>
                </ListItem>
            )}
        </List>
        </AccordionPanel>
        );
       

    }

    render() {
        
        var findActiveTab = '';
        ServerBOMItems=[]
        if (ActiveAccordianBgColor) {
            findActiveTab = "AccordianActiveTabfind"
        } else {
            findActiveTab = '';
        }
        if (Array.isArray(this.props.MapContent)) {
            this.loopConfigureItems(this.props.MapContent);
        } else {
            var data = [];
            data.push(this.props.MapContent);
            this.loopConfigureItems(data);
        }

        return (
            <Box margin="none" pad="none" justify='start' colorIndex="light-2" style={{ width: '100%', height: '100%' }} >
                <Box direction='row' style={{ padding: '5px', width: '100%', height: '7%' }} separator="bottom" justify='between' onClick={this.onDivClick} >
                    <Box direction='row' pad="none">
                        <Heading tag='h4' strong={true} margin='none' style={{ color: '#01a982' }}>{this.state.HeadingAcc} </Heading>
                    </Box>
                    {this.state.contentVisible ? <FormUp size='small' /> : <FormDown size='small' />}
                </Box>
                <Box direction='row' pad="none" style={{ height: '93%', overflow: 'auto', width: '100%' }}>
                    <Box direction='column' pad='none' style={{ width: '100%' }}>
                        <Animate visible={this.state.contentVisible} keep={false}
                            enter={{ "animation": "slide-down", "duration": 200, "delay": 0 }} >

                            <Accordion active={this.state.ActiveTabIndex1} className={findActiveTab} animate={this.state.animate} onActive={(e) => this.OpenParallelActive(e)} openMulti={true}>                                 
                                {this.getSummary()}    
                                {ConfigDetailsOfRackServers}
                            </Accordion>
                        </Animate>
                    </Box>
                </Box>
            </Box>
        );
    }
}
export default RackDetails;



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/RackDetails.js